import { RuntimeErrorMessage } from '@blaze-runtime/engine-domain';
import { type WorkflowNode } from '@blaze-shared/workflow-domain';

/**
 * Aborts execution of a node whose configuration cannot be executed — a missing target, an
 * unresolved reference, a node type that does not match its payload.
 *
 * @param missingProperties names of the properties the node should have carried, when known.
 */
export function throwInvalidNodeError(
  node: WorkflowNode | null,
  missingProperties?: string,
): never {
  console.error('Invalid node:', node);
  if (missingProperties?.length) {
    console.error('Node is missing properties:', missingProperties);
  }
  throw new Error(`${RuntimeErrorMessage.InvalidWorkflowNode}`);
}
